import { useEffect } from 'react';
import { trackPageView } from './gtag4';

const useTrackPageView = (screenName: string, params = {}, ready = true) => {
  useEffect(() => {
    if (!ready) return;

    trackPageView(screenName, params);
  }, [ready]);
};

export default useTrackPageView;
